/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../index.js";
export function IconGamesConsole(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M4.423 2.5a1.25 1.25 0 0 0-1.224.995l-1.652 7.923a1.313 1.313 0 0 0 2.423.925l1.57-2.718A1.25 1.25 0 0 1 6.622 9h2.756c.447 0 .86.238 1.083.625l1.57 2.718a1.313 1.313 0 0 0 2.422-.924l-1.652-7.924a1.25 1.25 0 0 0-1.224-.995H4.423zm-2.692.689A2.75 2.75 0 0 1 4.423 1h7.154a2.75 2.75 0 0 1 2.692 2.189l1.653 7.923a2.813 2.813 0 0 1-5.19 1.981L9.233 10.5H6.766L5.27 13.093a2.813 2.813 0 0 1-5.19-1.98l1.65-7.925z\'/><path d=\'M7 5.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0zm2 0a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M7.041 4a2.5 2.5 0 0 0-2.447 1.99L2.22 17.372a2.183 2.183 0 0 0 4.274.89l.474-2.272A2.5 2.5 0 0 1 9.415 14h5.17a2.5 2.5 0 0 1 2.447 1.99l.474 2.273a2.183 2.183 0 0 0 4.274-.892L19.406 5.99A2.5 2.5 0 0 0 16.96 4H7.04zM2.636 5.581A4.5 4.5 0 0 1 7.04 2h9.918a4.5 4.5 0 0 1 4.405 3.581l2.374 11.382a4.183 4.183 0 1 1-8.19 1.708l-.474-2.273a.5.5 0 0 0-.49-.398H9.416a.5.5 0 0 0-.49.398l-.473 2.273a4.183 4.183 0 1 1-8.19-1.708L2.636 5.581z\'/><path d=\'M10 8.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0zm4 0a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconGamesConsole is deprecated and will be archived soon. Use IconGamesConsole instead.
 */
export function Experimental__IconGamesConsole(props) {
  return /*#__PURE__*/React.createElement(IconGamesConsole, props);
}